import React, { useState, useEffect } from "react";
// import axios from "axios";
import {
  Box,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // Avatar, Popover, Button, CircularProgress
} from "@mui/material";
import {
  Folder,
  AccountCircle,
  FolderOutlined,
  MoreVert,
} from "@mui/icons-material";

import { useTheme } from "../style/theme";
import { useUser } from "../hooks/Authorize";
import { formatSize, getFileIconAndColor } from "./utils";
// import ItemMorevertMenu from "./ItemMorevertMenu.jsx";
import globalState from "./globalState";
import ListFilesFoldersOrganizer from "../components/ListFilesFoldersOrganizer";
import { useLocation, useNavigate } from "react-router-dom";
// import FileModal from "./Dialogs/FilePreviewModal.jsx";
import UserInfoMenu from "./SubMenus/UserInfoMenu.jsx";
// import { useResourceMenu } from "../context/ResourceMenuContext";
// import AddResourceMenu from "./SubMenus/AddResourceMenu.jsx";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const COLUMN_WIDTHS = {
  name: '25%',
  reason: '25%',
  owner: '25%',
  last_modified: '20%',
  size: '10%',
  location: '20%'
};

export const getMostRecentUserActivity = (userId, activities) => {
  if (!activities || activities.length === 0) {
    return { activity: "", time: "" };
  }

  // Filter activities by user and sort by timestamp (newest first)
  const userActivities = activities
    .filter(activity => activity.by === userId)
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

  if (userActivities.length === 0) {
    return { activity: "", time: "" };
  }

  const mostRecent = userActivities[0];
  const activityDate = new Date(mostRecent.timestamp);
  const now = new Date();

  // Format the time display
  let timeDisplay;
  if (activityDate.toDateString() === now.toDateString()) {
    // Today - show time like "9:35 AM"
    timeDisplay = activityDate.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  } else {
    // Not today - show date like "Jan 20, 2025"
    timeDisplay = activityDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  return {
    activity: mostRecent.name.toLowerCase(),
    time: timeDisplay
  };
};

const ListFilesFolder = ({ menuAnchorEl, setMenuAnchorEl, handleMoreVertMenuOpen, items, tableHeadings, setClikkleItems, selectedFilters, showTableHeader = true, handleFolderNavigationClick, handleDoubleClickFilePreview, handleRowClick }) => {
  // const [anchorEl, setAnchorEl] = useState(null); 

  // const [currentMenuClickedItem, setCurrentMenuClickedItem] = useState({});
  // const [sortedItems, setSortedItems] = useState([]);
  const { mode } = useTheme();
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const location = useLocation(); // Detects URL changes
  const navigate = useNavigate(); // Used for navigation
  var isRecentScreen = location.pathname === '/recent'
  var isHomeScreen = location.pathname === '/' || location.pathname === '/home'
  const queryParams = new URLSearchParams(location.search);
  const parentId = queryParams.get('parentId');

  var showLocationColumn = location.pathname === '/' || location.pathname === '/recent'
  // const [isImage, setIsImage] = useState(false);
  const [listFileFolderOrganizeSelectedOption, setListFileFolderOrganizeSelectedOption] = useState(
    globalState.getState("listFileFolderOrganizeSelectedOption")
  );

  // const [userInfoPopupOpen, setUserInfoPopupOpen] = useState(false);
  // const [userInfo, setUserInfo] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const userCache = useRef({});

  // const [menuAnchorEl, setMenuAnchorEl] = useState(null);        // for MoreVert menu
  const [userInfoPopup, setUserInfoPopup] = useState({
    anchorEl: null,
    itemId: null,
  });
  if (isHomeScreen) {
    // console.log(items)

  }



  const filteredAndSortedItems = [...items]
    .filter(item => {
      if (isRecentScreen || isHomeScreen) {
        // Check for uniqueness by _id AND (name + folderPath)
        const isUniqueById = items.findIndex(i => i._id === item._id) === items.indexOf(item);
        const isUniqueByNameAndPath = items.findIndex(i =>
          i.name === item.name &&
          i.folderPath === item.folderPath
        ) === items.indexOf(item);

        return isUniqueById && isUniqueByNameAndPath && item.type === "file";
      }
      return true;
    })
    .sort((a, b) => {
      if (listFileFolderOrganizeSelectedOption === "On top") {
        return a.type === "folder" && b.type === "file" ? -1 : a.type === "file" && b.type === "folder" ? 1 : 0;
      }
      return a.name.localeCompare(b.name);
    });

  const handleUserInfoClose = () => {
    setUserInfoPopup({ anchorEl: null, itemId: null });
  };





  // console.log('selectedFilters = ',selectedFilters)

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const parentId = params.get("parentId"); // Extract parentId from URL

    // console.log("parentId = ", parentId); // Debugging

    if (parentId) {
      // fetchFolderData(parentId); // Fetch folder data if parentId exists
    } else {
      // If parentId is removed, reset the data or refetch root-level items
      // console.log("No parentId, fetching root-level items...");
      // fetchRootData(); // Define this function to load default items
    }

    // Subscribe to global state updates if needed
    const unsubscribe = globalState.subscribe(({ key, value }) => {
      if (key === "listFileFolderOrganizeSelectedOption") {
        setListFileFolderOrganizeSelectedOption(value);
      }
    });

    return () => unsubscribe(); // Cleanup subscription
  }, [location.search]); // Re-run effect when query params change


  // const handleMoreVertMenuOpen = (event, item) => {
  //   setMenuAnchorEl(event.currentTarget); 
  //   setCurrentMenuClickedItem(item);
  //   console.log("Menu opened: ", item)
  // };







  function formateDate(dateString) {
    const formattedDate = new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    return formattedDate
  }


  if (parentId && items.length > 0 && items[0].parentId !== parentId) {
    return <></>
  }

  return (
    <>


      {
        1 &&
        // items.length > 0 &&
        <>
          <TableContainer
            sx={{

            }}
          >
            {/* <ItemMorevertMenu
              anchorEl={menuAnchorEl}
              setAnchorEl={setMenuAnchorEl}
              currentMenuClickedItem={currentMenuClickedItem}
              item={currentMenuClickedItem}
              setClikkleItems={setClikkleItems}
              items={items}
              handleDoubleClickFilePreview={handleDoubleClickFilePreview}
            /> */}
            <Table>
              {showTableHeader && <TableHead>
                <TableRow
                  sx={{ borderBottom: `2px solid ${mode === "light" ? "#e5e7eb" : "rgba(21, 21, 21, 1)"}`, }}
                >
                  {tableHeadings.name && (
                    <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.name, color: "rgba(100, 100, 100, 1)", paddingLeft: 3, borderTopRightRadius: "16px", borderBottomRightRadius: "16px" }}>
                      Name
                    </TableCell>
                  )}
                  {(tableHeadings.reason || isHomeScreen) && (
                    <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.reason, color: "rgba(100, 100, 100, 1)" }}>
                      Reason
                    </TableCell>
                  )}
                  {tableHeadings.owner && (
                    <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.owner, color: "rgba(100, 100, 100, 1)" }}>
                      Owner
                    </TableCell>
                  )}

                  {(tableHeadings.last_modified && !isHomeScreen) && (
                    <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.last_modified, color: "rgba(100, 100, 100, 1)" }}>
                      Last Modified
                    </TableCell>
                  )}


                  {((tableHeadings.sharing_date && !isHomeScreen) && !isHomeScreen) && (
                    <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.size, color: "rgba(100, 100, 100, 1)" }}>
                      Sharing Date
                    </TableCell>
                  )}

                  {((tableHeadings.size && !isHomeScreen) && !isHomeScreen) && (
                    <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.size, color: "rgba(100, 100, 100, 1)" }}>
                      Size
                    </TableCell>
                  )}


                  {showLocationColumn && (
                    <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.location, color: "rgba(100, 100, 100, 1)" }}>
                      Location
                    </TableCell>
                  )}

                  <TableCell sx={{ paddingRight: 3, paddingBottom: 0, paddingTop: 0, borderTopRightRadius: "6px", borderBottomRightRadius: "6px" }}>

                    {<ListFilesFoldersOrganizer />}

                  </TableCell>

                </TableRow>
              </TableHead>}
              <TableBody>
                {filteredAndSortedItems.map((item, i) => (
                  <TableRow
                    key={i}
                    onClick={() => handleRowClick(item)}


                    sx={{
                      borderBottom: `2px solid ${mode === "light" ? "#e5e7eb" : "rgba(22, 22, 22, 0)"}`,
                      height: "50px",
                      "&:hover .additional-icons": { visibility: "visible" },
                      "&:hover": {
                        backgroundColor: "custom.search.focus",
                        fontSize: "16px",
                        borderRadius: "25px",
                      },
                    }}
                  >
                    {tableHeadings.name && (
                      <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.name, paddingLeft: 3, borderTopLeftRadius: "6px", borderBottomLeftRadius: "6px" }}>
                        <Box display="flex" alignItems="center" gap="1rem">
                          {item.clikkle && item.type === "folder" && (
                            <Folder style={{ fontSize: 30, color: "#488BF1" }} />
                          )}                       {!item.clikkle && item.type === "folder" && (() => {
                            const { icon } = getFileIconAndColor({
                              type: item.type, // "file" or "folder"
                              extension: item.type === "file" ? item.name.split(".").pop().toLowerCase() : "",
                              isShortcut: item.isShortcut,
                              overrideColor: item.color,
                              mode: mode,
                              fontSize: 35

                            })
                              ;
                            return icon;
                          })()}                       {item.type === "file" && (() => {
                            const { icon } = getFileIconAndColor({
                              type: item.type, // "file" or "folder"
                              extension: item.type === "file" ? item.name.split(".").pop().toLowerCase() : "",
                              isShortcut: item.isShortcut,
                              mode: mode,
                              fontSize: 35

                            })
                              ;
                            return icon;
                          })()}


                          <Typography
                            onDoubleClick={() => handleFolderNavigationClick(item)}

                            variant="body1"
                            whiteSpace={'nowrap'}
                            sx={{
                              color: `${mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#fff"
                                } `,
                              fontSize: "16px",
                              // fontWeight:600
                            }}
                          >

                            {
                              (() => {
                                let name = item.name || '';

                                // Remove extension if type is 'file'
                                if (item.type === 'file') {
                                  const lastDotIndex = name.lastIndexOf('.');
                                  if (lastDotIndex > 0) {
                                    name = name.substring(0, lastDotIndex);
                                  }
                                }

                                // Truncate if longer than 12 characters
                                return name.length > 25 ? `${name.substring(0, 25)}...` : name;
                              })()
                            }


                          </Typography>
                        </Box>
                      </TableCell>
                    )}
                    {(tableHeadings.reason || isHomeScreen) && (
                      <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.reason }}>
                        <Box display="flex" alignItems="center" gap="1rem">
                          <Typography
                            variant="body1"
                            whiteSpace={'nowrap'}
                            sx={{
                              color: `${mode === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(165, 165, 165, 1)"} `,
                              fontSize: "16px"
                            }}
                          >
                            {(() => {
                              const recentActivity = getMostRecentUserActivity(platformUser._id, item.activities);
                              return (
                                <>
                                  <b>You {recentActivity.activity}</b>
                                  <FiberManualRecordIcon sx={{ fontSize: 8, mx: 1 }} />
                                  {recentActivity.time}
                                </>
                              );
                            })()}
                          </Typography>
                        </Box>
                      </TableCell>
                    )}

                    {tableHeadings.owner && (
                      <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.owner }}>
                        <Box
                          display="flex"
                          alignItems="center"
                          gap="1rem"

                          sx={{ cursor: 'pointer' }} // Add pointer cursor for better UX
                        >

                          <div
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent event bubbling
                              setUserInfoPopup({ anchorEl: e.currentTarget, itemId: item._id });
                            }}
                            style={{
                              border: "2px solid #4B67F0", // Outer border
                              borderRadius: "50%",
                              padding: 2, // Space between border and inner background
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: mode === "dark" ? "#A7AFFD" : "rgb(119, 140, 245)",
                                borderRadius: "50%",
                                width: 22,
                                height: 22,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <AccountCircle style={{ fontSize: 18, color: "white" }} />
                            </div>
                          </div>


                          <Typography
                            variant="body1"
                            whiteSpace="nowrap"
                            sx={{
                              color: `${platformUser?.mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#fff"}`,
                              fontSize: "16px",
                            }}
                          >
                            {item.ownerEmail === platformUser?.email ? "Me" : item.ownerEmail}
                          </Typography>

                          <UserInfoMenu
                            item={item}
                            anchorEl={userInfoPopup.itemId === item._id ? userInfoPopup.anchorEl : null}
                            onClose={handleUserInfoClose}
                          />
                        </Box>
                      </TableCell>
                    )}


                    {(tableHeadings.last_modified && !isHomeScreen) && (
                      <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.last_modified }}>
                        <Box display="flex" alignItems="center" gap="1rem">
                          <Typography
                            variant="body1"
                            whiteSpace={'nowrap'}
                            sx={{
                              color: `${mode === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(165, 165, 165, 1)"} `,
                              fontSize: "16px",

                            }}
                          >
                            {formateDate(item.updatedAt)}
                          </Typography>
                        </Box>
                      </TableCell>
                    )}


                    {(tableHeadings.sharing_date && !isHomeScreen) && (
                      <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.last_modified }}>
                        <Box display="flex" alignItems="center" gap="1rem">
                          <Typography
                            variant="body1"
                            whiteSpace={'nowrap'}
                            sx={{
                              color: `${mode === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(165, 165, 165, 1)"} `,
                              fontSize: "16px",

                            }}
                          >
                            {(() => {
                              // 1. Find the sharing entry for current platform user
                              const sharedEntry = item.sharedWith?.find(
                                share => share.userId === platformUser._id
                              );

                              // 2. If found and has timestamp, format it
                              if (sharedEntry?.timestamp) {
                                return formateDate(sharedEntry.timestamp);
                              }

                              // 3. Return empty or default if no match
                              return null; // or return '-', 'Not Shared', etc.
                            })()}
                          </Typography>
                        </Box>
                      </TableCell>
                    )}
                    {(tableHeadings.size && !isHomeScreen) && (
                      <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.size }}>
                        <Box display="flex" alignItems="center" gap="1rem">
                          <Typography
                            variant="body1"
                            whiteSpace={'nowrap'}
                            sx={{
                              color: `${mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#fff"} `,
                              fontSize: "16px",

                            }}
                          >
                            {item.type === 'file' ?
                              (typeof item.size === 'number' && !isNaN(item.size) ? formatSize(item.size) : item.size)
                              : item.size
                            }
                          </Typography>
                        </Box>
                      </TableCell>
                    )}

                    {showLocationColumn && (
                      <TableCell padding="none" sx={{ height: "100%", width: COLUMN_WIDTHS.location }}>
                        <Box
                          onClick={() => navigate(item.ownerId === platformUser._id ? "/my-files" : "/shared-with-me")}

                          display="flex"
                          alignItems="center"
                          sx={{
                            color: mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#fff",
                            border: "1px solid rgba(255, 255, 255, 0.3)",
                            borderRadius: "12px",
                            padding: "4px 12px",
                            backgroundColor: "transparent",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "14px",
                            height: 35,
                            // color: "rgba(165, 165, 165, 1)",
                            fontWeight: "bold",
                            width: "fit-content", // 👈 Ensures the Box only takes needed space
                            "&:hover": {
                              borderColor: "rgba(255, 255, 255, 0.6)",
                              backgroundColor: "rgba(255, 255, 255, 0.1)",
                              cursor: "pointer",
                            },
                          }}

                        // component={Link} 
                        // to={item.ownerId === platformUser._id ? "/my-files" : "/shared-files"} 
                        >
                          <FolderOutlined style={{ fontSize: 18, color: "#A5A5A5" }} />
                          <Typography variant="body1" noWrap sx={{ textDecoration: "none" }}>
                            {
                              item.ownerId === platformUser._id ? "My Files" : "Shared With Me"
                            }
                          </Typography>
                        </Box>
                      </TableCell>
                    )}

                    {/* Actions Column */}
                    <TableCell padding="none" sx={{ height: "100%", paddingRight: 3, borderTopRightRadius: "6px", borderBottomRightRadius: "6px" }}>
                      <Box
                        display="flex"
                        alignItems="center"
                        gap="1rem"
                        justifyContent={"end"}
                      >

                        <IconButton
                          onClick={(e) => handleMoreVertMenuOpen(e, item)}
                          sx={{ color: "#A5A5A5" }}
                        >
                          <MoreVert style={{ fontSize: 24 }} />
                        </IconButton>
                      </Box>
                    </TableCell>


                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      }
    </>

  );
};

export default ListFilesFolder;
